if (!customElements.get('sister-products')) {
    class SisterProducts extends HTMLElement {
        constructor() {
        super();

        this.accordion = this.querySelector(".main-product__variant-picker__accordion");
        this.scents = this.accordion.querySelectorAll('a');
        this.activeScent = this.accordion.querySelector('a.__active');
        this.firstScent = this.accordion.querySelector('a.__first');
        this.moreButton = this.querySelector('.main-product__variant-picker__button');

        this.setupListeners();
        }

        setupListeners() {
            this.scents.forEach((scent) => {
                scent.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (e.target != this.activeScent){
                        this.switchScents(e.target);
                    }
                });
            });

            if (this.moreButton) {
                this.moreButton.addEventListener('click', (e) => {
                    this.accordion.classList.toggle("__open");

                    if (this.firstScent != this.activeScent){
                        this.firstScent.classList.remove("__first");
                        this.firstScent = this.activeScent;
                        this.activeScent.classList.add("__first");
                    }
                    
                });
            }
        }

        switchScents(scent) {
            scent.classList.add("__loading");

            const scentDetails = 'sticky-scent-details';
            const handle = scent.href.split('/products/')[1].split('?')[0];
            const variantId = scent.dataset.variantId || '';

            const sectionIdUrl = `/products/${handle}?section_id=${scent.dataset.sectionId}&variant=${variantId}`;
            const stickyDetailsUrl = `${scent.href}?sections=${scentDetails}`;

            // Fetch main-product (section_id ensures blocks work)
            const mainFetch = fetch(sectionIdUrl).then(res => res.text());
            
            // Fetch sticky scent section (sections param is fine)
            const stickyFetch = fetch(stickyDetailsUrl).then(res => res.json());

            Promise.all([mainFetch, stickyFetch])
                .then(([mainHTML, stickyData]) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(mainHTML, 'text/html');

                    // Replace images
                    let targetElement = document.querySelector(".main-product__media__stacked");
                    let replacementElement = doc.querySelector('.main-product__media__stacked');
                    if (targetElement && replacementElement) {
                        targetElement.outerHTML = replacementElement.outerHTML;
                    }

                    // Replace buy buttons
                    targetElement = document.querySelector(".main-product__info__buy-buttons");
                    replacementElement = doc.querySelector('.main-product__info__buy-buttons');
                    if (targetElement && replacementElement) {
                        targetElement.outerHTML = replacementElement.outerHTML;
                    }

                    // Replace icon
                    targetElement = document.querySelector(".main-product__variant-picker__accordion ~ img");
                    replacementElement = doc.querySelector('.main-product__variant-picker__accordion ~ img');
                    if (replacementElement) {
                        if (targetElement){
                            targetElement.outerHTML = replacementElement.outerHTML;
                        } else {
                            targetElement = document.querySelector(".main-product__variant-picker__accordion");
                            targetElement?.appendChild(replacementElement.outerHTML);
                        }
                    }

                    // Replace subscription widget
                // console.log(window.Recharge);
                // window.Recharge.createWidget({ productId: 123 });
                // window.Recharge.initSubscriptionWidget();
                
                    targetElement = document.querySelector(".recharge-subscription-widget");
                    targetElement?.remove();
                /* replacementElement = doc.querySelector('.recharge-subscription-widget .rc-widget');
                    if (targetElement && replacementElement) {
                        targetElement.outerHTML = replacementElement.outerHTML;
                    } */
                //  console.log(window.Recharge, window.ReChargeWidget);
                //  document.dispatchEvent(new Event('recharge:load'));

                    // Replace delivery methods
                    targetElement = document.querySelector(".main-product__delivery-methods");
                    replacementElement = doc.querySelector('.main-product__delivery-methods');
                    if (targetElement && replacementElement) {
                        targetElement.outerHTML = replacementElement.outerHTML;
                    }

                    // Themed color update
                    targetElement = document.querySelector(".main-product__info");
                    if (targetElement && scent.dataset.color ){
                        targetElement.style.setProperty('--themed-color-foreground', scent.dataset.color);
                        targetElement.style.setProperty('--themed-color-foreground-text', scent.dataset.colorText);
                    }

                    // Update title - currently inlined style display none, could potentially remove
                    targetElement = document.querySelector(".main-product__info__scent");
                    if (targetElement) {
                        targetElement.innerHTML = scent.innerHTML;
                    }

                    //update sticky bar
                    targetElement = document.querySelector("product-form");
                    if (targetElement) {
                        targetElement.removeStickyBar();
                        targetElement.createStickyBar(targetElement);
                    }

                    // Update active scent button
                    scent.classList.remove("__loading");
                    this.activeScent.classList.remove("__active");
                    this.activeScent = scent;
                    this.activeScent.classList.add("__active");

                    // Update URL
                    window.history.replaceState({}, '', scent.href);

                    // Replace sticky scent section
                    const targetSection = document.querySelector(`.sticky-scent-details`)?.closest('.shopify-section');
                    if (targetSection && stickyData[scentDetails]) {
                        targetSection.outerHTML = stickyData[scentDetails];
                    }
                })
                .catch(error => {
                    console.error('Section update failed:', error);
                    window.location.href = scent.href;
                });
        }
    }

    customElements.define('sister-products', SisterProducts);
}